
import { createContext, useContext, useLayoutEffect, useCallback, useState, useMemo, useRef, useReducer } from 'react'

const LayoutContext = createContext();

export default function useLayout() {
    return useContext(LayoutContext)
}

export function LayoutProvider({ children }) {

    // console.log('layout provider render')
    const measureDimensions = useCallback(() => {
        // console.log('measuring dimensions')
        let w0 = Math.floor(window.innerWidth)
        let h0 = Math.floor(window.innerHeight * 0.87)
        // overlay with a new 100 x 100 coordinate system that maps directly to px position values (screen size set in CSS)
        let w = []; let h = [];
        for (let i = 0; i <= 100; i++) {
            w.push(w0 / 100 * i)
        }
        for (let i = 0; i <= 100; i++) {
            h.push(h0 / 100 * i)
        }
        return ({ w0, h0, w, h })
    }, [])

    const [dimensions, setDimensions] = useReducer(measureDimensions, measureDimensions())

    const touchScreen = useMemo(() => {
        if (!dimensions) return null;
        return !window.matchMedia('(hover: hover)').matches
    }, [dimensions])

    const orientation = useMemo(() => {
        if (!dimensions) return null
        //could just use a simple boolean too, but string comes in handy l8r when working with BGimgs
        // console.log('orientation hook', window.screen.orientation) //also gives primary, secondary
        if (window.matchMedia('(orientation: landscape)').matches) return 'landscape'
        else return 'portrait';
    }, [dimensions])

    const platform = useMemo(() => {
        // console.log('platform hook', dimensions, orientation, touchScreen)
        if (!dimensions) return null;
        if (touchScreen) {
            if (orientation === 'landscape') {
                if (dimensions.h0 < 576) return 'mobile'
                else return 'tablet'
            }
            else {
                if (dimensions.w0 < 576) return 'mobile'
                else return 'tablet'
            }
        }
        else return 'desktop'
    }, [dimensions, orientation, touchScreen])

    useLayoutEffect(() => {
        window.addEventListener('resize', setDimensions)
        return () => window.removeEventListener('resize', setDimensions)
    }, [])

    return (
        <LayoutContext.Provider value={{
            dimensions,
            touchScreen,
            orientation,
            platform,
        }}>
            {children}
        </LayoutContext.Provider>
    )
}

